var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinear = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  "data-icon": "tick",
  "data-variant": "linear",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m4.563 12 4.952 4.953 9.923-9.905"
})));
export { SvgLinear as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBkYXRhLWljb249InRpY2siIGRhdGEtdmFyaWFudD0ibGluZWFyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIxLjUiPgoKPHBhdGgKZD0iTSA0LjU2MjUgMTIgTCA5LjUxNSAxNi45NTI1IEwgMTkuNDM3NSA3LjA0NzYiCnN0cm9rZT0iY3VycmVudENvbG9yIgovPgo8L3N2Zz4K";